"use client"

import type { PropsWithChildren } from "react"
import { ChakraProvider } from "@chakra-ui/react"
import { system } from "@/theme"

export function Provider(props: PropsWithChildren) {
  return <ChakraProvider value={system}>{props.children}</ChakraProvider>
}
